/* Rücksprung nach Login und Newsletter-Bestätigung (snippets/newsletter-return-helper.liquid).
   data-artikel / data-kunde am Script-Tag sagen, ob es eine Anleitung ist und ob jemand eingeloggt ist. */
(function() {
  var CFG = (document.currentScript && document.currentScript.dataset) || {};
  var RETURN_KEY    = 'modolino_return_article';
  var CONFIRMED_KEY = 'modolino_nl_confirmed';
  var MAX_AGE       = 24 * 60 * 60 * 1000; // 24 Stunden
  var SEITE_GELADEN = Date.now();

  function getJSON(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
  }
  function setJSON(key, obj) {
    try { localStorage.setItem(key, JSON.stringify(obj)); } catch (e) {}
  }
  function remove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }
  remove('mdl_login_debug'); /* altes Debug-Protokoll aus früheren Versionen aufräumen */

  /* Echte Scroll-Position ermitteln – auch wenn ein Modal die Seite
     gerade mit position:fixed eingefroren hat (dann steht die wahre
     Position als negativer Wert in body.style.top). */
  function echteScrollPosition() {
    var b = document.body;
    if (b && b.style.position === 'fixed' && b.style.top) {
      var t = parseInt(b.style.top, 10);
      if (!isNaN(t)) return Math.abs(t);
    }
    return window.scrollY || window.pageYOffset || 0;
  }

  function scrollGesperrt() {
    return document.body && document.body.style.position === 'fixed';
  }

  if (CFG.artikel === 'true') {
  /* ── 1) Experiment-Seite besucht → URL als Rücksprungziel merken. ── */
  setJSON(RETURN_KEY, { url: location.pathname, ts: Date.now() });

  /* Scroll-Position beim Klick auf Freischalten-Buttons merken */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.pdf-cta-button, .pdf-mini-button')) {
      if (typeof window.mdlTrack === 'function') window.mdlTrack('Anleitung_Freischalten', {});
      setJSON('mdl_article_scroll', { url: location.pathname, y: echteScrollPosition(), ts: Date.now() });
    }
  }, true);

  /* Auto-Download nach Rückkehr von der Bestätigungsseite */
  document.addEventListener('DOMContentLoaded', function() {
    if (location.hash === '#nl-bestaetigt') {
      history.replaceState(null, '', location.pathname);

      var sp = getJSON('mdl_article_scroll');
      if (sp && sp.url === location.pathname && (Date.now() - sp.ts) < MAX_AGE) {
        remove('mdl_article_scroll');
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        (function (ziel) {
          var abgebrochen = false;
          function abbrechen() { abgebrochen = true; }
          ['wheel', 'touchstart'].forEach(function (ev) {
            window.addEventListener(ev, abbrechen, { passive: true, once: true });
          });
          window.addEventListener('keydown', function (e) {
            if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(e.key) !== -1) abbrechen();
          }, { passive: true });
          function springen() {
            if (abgebrochen || scrollGesperrt()) return;
            window.scrollTo(0, ziel);
          }
          springen();
          window.addEventListener('load', function () { setTimeout(springen, 0); });
          var aktiveZeit = 0;
          var timer = setInterval(function () {
            if (abgebrochen) { clearInterval(timer); return; }
            if (scrollGesperrt()) return;
            aktiveZeit += 200;
            var maxScroll = Math.max(0, (document.documentElement.scrollHeight || 0) - window.innerHeight);
            if (ziel <= maxScroll + 2) {
              var aktuell = window.scrollY || window.pageYOffset || 0;
              if (Math.abs(aktuell - ziel) > 1) {
                window.scrollTo(0, ziel);
              }
            }
            if (aktiveZeit >= 6000) { clearInterval(timer); }
          }, 200);
        })(sp.y);
      }

      var btn = document.querySelector('.pdf-cta-button');
      if (btn) setTimeout(function() { btn.click(); }, 600);
    }
  });
  }

  /* ── 2) Altes Tab: Sofort-Signal aus dem Bestätigungs-Tab → neu laden.
         Vorher die Position sichern – nach dem Reload stellt das Script
         in newsletter-optin-popup.liquid sie über 'mdl_scroll_pos' wieder her. ── */
  window.addEventListener('storage', function(e) {
    if (e.key === CONFIRMED_KEY && e.newValue) {
      try { sessionStorage.setItem('modolino_reloaded_after_confirm', '1'); } catch (err) {}
      try { sessionStorage.setItem('mdl_scroll_pos', String(echteScrollPosition())); } catch (err) {}
      location.reload();
    }
  });

  /* ── 3) Fallback: Rückkehr zum Tab → einmalig neu laden ── */
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState !== 'visible') return;
    var confirmed = getJSON(CONFIRMED_KEY);
    var alreadyReloaded = false;
    try { alreadyReloaded = sessionStorage.getItem('modolino_reloaded_after_confirm') === '1'; } catch (e) {}
    /* Nur neu laden, wenn die Bestätigung NACH dem Laden dieser Seite kam */
    if (confirmed && confirmed.ts > SEITE_GELADEN && (Date.now() - confirmed.ts) < MAX_AGE && !alreadyReloaded) {
      try { sessionStorage.setItem('modolino_reloaded_after_confirm', '1'); } catch (e) {}
      try { sessionStorage.setItem('mdl_scroll_pos', String(echteScrollPosition())); } catch (e) {}
      location.reload();
    }
  });

  /* ── 4) Seite UND Scroll-Position über den Shopify-Code-Login retten ── */
  var LOGIN_SCROLL_KEY = 'mdl_login_scroll';
  var TRACK_KEY        = 'mdl_scroll_track';
  var RUECKSPRUNG_MAX  = 30 * 60 * 1000; // 30 Minuten: Zeit für den Login mit Code aus der E-Mail


  if (CFG.kunde !== 'true') {
  /* Laufend die Scroll-Position mitschreiben – aber NICHT, während ein
     Modal die Seite eingefroren hat (sonst würde 0 mitgeschrieben). */
  var trackTimer = null;
  window.addEventListener('scroll', function () {
    if (trackTimer) return;
    trackTimer = setTimeout(function () {
      trackTimer = null;
      if (scrollGesperrt()) return;
      try {
        localStorage.setItem(TRACK_KEY, JSON.stringify({
          url: location.pathname,
          y: window.scrollY || window.pageYOffset || 0,
          ts: Date.now()
        }));
      } catch (e) {}
    }, 250);
  }, { passive: true });

  /* Beim Start des Logins URL + echte Position merken */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('shopify-account') ||
        e.target.closest('.pdf-login-modal-btn--primary')) {
      /* nur echte Klicks zählen – das PDF-Fenster klickt das Konto-Symbol per Code an */
      if (e.isTrusted && typeof window.mdlTrack === 'function') {
        window.mdlTrack('Login_Start', { Quelle: e.target.closest('shopify-account') ? 'Kopfzeile' : 'Anleitungs-Fenster' }, { spaeter: true });
      }
      var y = echteScrollPosition();
      try {
        localStorage.setItem('modolino_return_url', location.pathname);
        localStorage.setItem('modolino_return_url_ts', Date.now().toString());
        localStorage.setItem(LOGIN_SCROLL_KEY, JSON.stringify({
          url: location.pathname,
          y: y,
          ts: Date.now()
        }));
      } catch (err) {}
    }
  }, true);
  }

  if (CFG.kunde === 'true') {
  /* Wiederherstellen nach dem Login (gleiche Seite, max. 30 Minuten) */
  (function () {
    var d = null;
    try { d = JSON.parse(localStorage.getItem(LOGIN_SCROLL_KEY)); } catch (e) {}
    if (!d || !d.url) return;
    if ((Date.now() - d.ts) > RUECKSPRUNG_MAX) {
      try { localStorage.removeItem(LOGIN_SCROLL_KEY); } catch (e) {}
      return;
    }
    if (d.url !== location.pathname) {
      return;
    }
    try { localStorage.removeItem(LOGIN_SCROLL_KEY); } catch (e) {}

    /* Klick-Wert bevorzugen; Tracker nur als Fallback, falls der
       Klick-Wert 0 ist und der Tracker etwas Besseres weiß */
    var ziel = d.y;
    var track = null;
    try { track = JSON.parse(localStorage.getItem(TRACK_KEY)); } catch (e) {}
    if (ziel === 0 && track && track.url === d.url && track.y > 0 && (Date.now() - track.ts) < RUECKSPRUNG_MAX) {
      ziel = track.y;
    }

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    var abgebrochen = false;
    function abbrechen() { abgebrochen = true; }
    ['wheel', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, abbrechen, { passive: true, once: true });
    });
    window.addEventListener('keydown', function (e) {
      if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(e.key) !== -1) abbrechen();
    }, { passive: true });

    function springen() {
      if (abgebrochen || scrollGesperrt()) return;
      window.scrollTo(0, ziel);
    }

    springen();
    document.addEventListener('DOMContentLoaded', springen);
    window.addEventListener('load', function () { setTimeout(springen, 0); });

    /* Nachjustieren: 6 Sekunden aktive Zeit; Popup-Sperre pausiert das Budget */
    var aktiveZeit = 0;
    var timer = setInterval(function () {
      if (abgebrochen) { clearInterval(timer); return; }
      if (scrollGesperrt()) return;
      aktiveZeit += 200;
      var maxScroll = Math.max(0, (document.documentElement.scrollHeight || 0) - window.innerHeight);
      if (ziel <= maxScroll + 2) {
        var aktuell = window.scrollY || window.pageYOffset || 0;
        if (Math.abs(aktuell - ziel) > 1) {
          window.scrollTo(0, ziel);
        }
      }
      if (aktiveZeit >= 6000) { clearInterval(timer); }
    }, 200);
  })();
  }
})();
